import trackWithSgtm from './trackWithSgtm'

export { trackWithSgtm }
